// extracted by mini-css-extract-plugin
export default {"button":"back-button__button___TgB9T"};